import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import Strings from '../../../../Strings';
import { lastActivityDisplay, makeValid } from '../../../../utils';
import { DATE_MONTH_DAY_YEAR } from '../../../../constants';
import TableWidget from '../component/TableWidget';
import { ORG_FEATURES, PERMISSIONS, hasPermission, orgFeatureEnabled } from '../../../../utils/userPermissions';

const renderAddress = address => {
  if (!address) {
    return '';
  }

  const { street, street2, city, state, zip, country } = address;
  return [street, street2, city, state, zip, country].filter(Boolean).join(', ');
};

function PatientDetails({ isCollapsible = false, ...props }) {
  const { patientDetails, isLoading } = props;

  const data = [
    [Strings.capPatient.patientId, patientDetails?.pharmacyPatientId],
    [Strings.capPatient.mrn, patientDetails?.mrn],
    [Strings.patientNameText, patientDetails?.patientName],
    [Strings.capPatient.dob, moment(patientDetails?.dateOfBirth).format(DATE_MONTH_DAY_YEAR)],
    [Strings.gender, makeValid(patientDetails?.gender)],
    [
      Strings.language,
      patientDetails?.language && Strings.languagesEnum[patientDetails?.language]
        ? Strings.languagesEnum[patientDetails?.language]
        : '',
    ],
    [Strings.capPatient.mobileNumber, makeValid(patientDetails?.textPhoneNo)],
    [Strings.capPatient.email, makeValid(patientDetails?.email)],
    [Strings.capPatient.address, makeValid(renderAddress(patientDetails?.address) || patientDetails?.homeAddress)],
    [Strings.timezone, makeValid(patientDetails?.timezone)],
    [
      Strings.capPatient.notifications,
      patientDetails?.smsNoticeEnabled 
        ? Strings.enabled
        : patientDetails?.manualSmsEnabled
        ? Strings.capPatient.disabledWithExeptionOfManualSMS
        : Strings.disabled
    ],
  ];
  if (orgFeatureEnabled(ORG_FEATURES.patient_portal_access)) {
    data.push([Strings.lastLogin, lastActivityDisplay(patientDetails?.last_login)]);
  }
  const canEdit = hasPermission(PERMISSIONS.CARE_MANAGEMENT_PATIENT_INFO_EDIT);

  return (
    <TableWidget
      title={Strings.capPatient.patientDetails}
      buttons={props.onEdit && canEdit ? [{ icon: 'edit', onClick: props.onEdit, id: 'edit-patient-details-button' }] : []}
      data={data}
      isLoading={isLoading}
      firstColumnClassName="patient-details-col"
      isCollapsible={isCollapsible}
    />
  );
}

PatientDetails.propTypes = {
  isLoading: PropTypes.any,
  patientDetails: PropTypes.shape({
    address: PropTypes.shape({
      city: PropTypes.any,
      country: PropTypes.any,
      state: PropTypes.any,
      street: PropTypes.any,
      street2: PropTypes.any,
      zip: PropTypes.any,
    }),
    dateOfBirth: PropTypes.any,
    email: PropTypes.any,
    gender: PropTypes.any,
    homeAddress: PropTypes.any,
    language: PropTypes.any,
    last_login: PropTypes.any,
    manualSmsEnabled: PropTypes.any,
    mrn: PropTypes.any,
    patientName: PropTypes.any,
    pharmacyPatientId: PropTypes.any,
    primaryPhoneNo: PropTypes.any,
    smsNoticeEnabled: PropTypes.any,
    textPhoneNo: PropTypes.any,
    timezone: PropTypes.any,
  }),
  onEdit: PropTypes.func,
  isCollapsible: PropTypes.bool,
};

PatientDetails.widgetId = 'PatientDetailsWidget';

export default PatientDetails;
